<div class="video-controls">
  <button class="ctrl-btn" (click)="onTogglePlay.emit()">
    @if (isPlaying) {
      <svg viewBox="0 0 24 24" fill="white">
        <rect x="6" y="4" width="4" height="16" />
        <rect x="14" y="4" width="4" height="16" />
      </svg>
    } @else {
      <svg viewBox="0 0 24 24" fill="white"><polygon points="6,4 20,12 6,20" /></svg>
    }
  </button>
  @if (isLive) {
    <span class="live-tag">Live</span>
  }
  <div class="progress-track">
    <div class="progress-fill" [style.width.%]="progressPercent"></div>
    <div class="progress-thumb" [style.left.%]="progressPercent"></div>
  </div>
  <div class="volume-control">
    <button class="ctrl-btn">
      <svg viewBox="0 0 24 24" fill="white">
        <path
          d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"
        />
      </svg>
    </button>
    <div class="volume-slider">
      <div class="volume-level" [style.width.%]="volumePercent"></div>
    </div>
  </div>
  <span class="time-display">{{ time }}</span>
  <button class="ctrl-btn">
    <svg fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24">
      <path
        d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
      />
    </svg>
  </button>
</div>
